export default __webpack_public_path__ + "static/media/bottomSemiCircle.2c9a6fdb.svg";